
import { Action, Component, Getter, State, Vue } from 'nuxt-property-decorator';
// import CommunityComponent from '~/components/Home/Community.vue';
// import Info from '~/components/Home/Info.vue';
// import VideoPlayer from '~/components/Player/VideoPlayer.vue';
// import ImageWithTextRow from '~/components/UIComponents/ImageWithTextRow.vue';
import { IUser } from '~/store/profile/types';
import { TSiteConfigState, ThemeName } from '~/store/types';
// import LandingPromoCarousel from '~/components/Home/LandingPromoCarousel.vue';
// import SignUpRow from '~/components/UIComponents/SignUpRow.vue';
// import MarketingBanner from '~/components/Sanity/MarketingBanner.vue';
import { buildSanityRouteMeta } from '~/utils/htmlHead';
import { MuxStreamTypes } from '~/types/mux-player';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import LargeCTABackgroundPanel from '~/components/UIComponents/LargeCTABackgroundPanel.vue';
import LandingAboutFilmGrid from '~/components/Home/LandingAboutFilmGrid.vue';
import RZRTrailerTakeover from '~/components/Home/RZRTrailerTakeover.vue';
import FilmsPromoPosterCarousel from '~/components/Home/FilmsPromoPosterCarousel.vue';
import LandingSocialGrid from '~/components/Home/LandingSocialGrid.vue';
import ProjectNftPromotion from '~/components/Films/ProjectNftPromotion.vue';

@Component({
  components: {
    LargeCTABackgroundPanel,
    LandingAboutFilmGrid,
    RZRTrailerTakeover,
    FilmsPromoPosterCarousel,
    LandingSocialGrid,
    ProjectNftPromotion,
  },
  meta: {
    theme: ThemeName.DARK,
  },
  head() {
    const c = this as LandingPage;
    return c.siteConfigState?.data?.seo
      ? buildSanityRouteMeta(c, c.siteConfigState.data.seo)
      : {};
  },
})
export default class LandingPage extends Vue {
  @State((profile) => profile.user, { namespace: 'profile' })
  currentUser!: IUser;

  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  @Action('showProjectNftPromotion', { namespace: 'projects' })
  private showProjectNftPromotion!: (projectSlug: string) => void;

  muxStreamType = MuxStreamTypes.ON_DEMAND;
  docType = SanityDocumentSchema.VIDEO;

  get shouldShowFilmNodeBuyPage() {
    return this.siteConfigState?.data?.shouldShowFilmNodeBuyPage;
  }

  get shouldShowLandingCarousel() {
    return this.siteConfigState?.data?.shouldShowLandingCarousel;
  }

  get shouldShowPriorityPassExchange() {
    return this.siteConfigState?.data?.shouldShowPriorityPassExchange;
  }

  get priorityPassBaseId() {
    return this.siteConfigState?.data?.priorityPassBaseId;
  }
  get primaryHomePageBannerRef() {
    return this.siteConfigState?.data?.homePageBanners?.[0]?._ref || '';
  }

  get heroVideoRef() {
    return this.siteConfigState?.data?.homePageHeroVideo?._ref;
  }

  get carouselBanners() {
    const partnerBanners: any = [
      {
        title: 'Special Concerts',
        titleLine2: '',
        text: "Collect all 17 NFT tracks on the new record and become part of the VIP scene you've always dreamed of, with small audience live concerts, just for NFT collectors.",
        text2:
          'Each Stash Box will contain 1 song NFT from the B.O.D.R. album.',
        image:
          'https://static.gala.games/images/gala-film/landing-page/film-pass-box.png',
      },
      {
        title: 'Parties at Snoop’s LA mansion ',
        titleLine2: '',
        text: "Have what it takes to party with Snoop Dogg himself? Collect all 17 track NFTs from the new album and you'll have the chance to find out!",
        text2: "Snoop's Stash Boxes are packed deep with future rewards.",
        image:
          'https://static.gala.games/images/gala-film/landing-page/film-pass-box.png',
      },
      {
        title: 'Limited edition Death Row Bling',
        titleLine2: '',
        text: 'Sparkle like a true fan should. Collect all 17 NFT tracks from the album to get an exclusive limited edition Death Row Records chain, as worn by the Doggfather himself.',
        text2:
          'Some rewards are physical, some are digital, and there are many more to come. To start on your Listen-to-Earn journey, get a Stash Box today.',
        image:
          'https://static.gala.games/images/gala-film/landing-page/film-pass-box.png',
      },
    ];

    return partnerBanners;
  }

  homepageRzrImages = {
    sm: require('@/assets/home/homepage-bottom-cta.jpg'),
    md: require('@/assets/home/homepage-bottom-cta@2x.jpg'),
    lg: require('@/assets/home/homepage-bottom-cta@3x.jpg'),
    xl: require('@/assets/home/homepage-bottom-cta@4x.jpg'),
  };

  scroll() {
    (this.$refs['signup-container'] as HTMLElement)?.scrollIntoView({
      behavior: 'smooth',
    });
  }

  goTo(route: string) {
    this.$router.push(route);
  }

  mounted() {
    setTimeout(() => {
      this.showProjectNftPromotion('rzr');
    }, 1000);
  }
}
